var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:({
      position: 'fixed',
      display: 'flex',
      top: ((_vm.content.y) + "px"),
      left: ((_vm.content.x) + "px"),
      zIndex: _vm.index,
      textAlign: _vm.content.align,
      transform: _vm.content.transform,
        flexDirection: 'column',
        display: 'flex',
        justifyContent: _vm.content.valign ? _vm.content.valign === 'top' ? 'flex-start' : _vm.content.valign === 'bottom' ? 'flex-end' : 'center': 'center',

      width: ((_vm.content.width || 200) + "px"),
      height: _vm.content.height ? ((_vm.content.height) + "px") : null,
      fontFamily: _vm.content.mainFont,
      fontSize: ((_vm.content.mainFontSize) + "px"),
      backgroundColor: (_vm.content.backgroundColor && _vm.content.backgroundColor.hexa) ? _vm.content.backgroundColor.hexa : null,
      color: (_vm.content.foreGroundColor && _vm.content.foreGroundColor.hexa) ? _vm.content.foreGroundColor.hexa : null,
  })},[_c('editor-content',{staticClass:"content-editor",style:({
    textAlign: _vm.content.align
  }),attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }